import FaceRetouchingNaturalOutlinedIcon from '@mui/icons-material/FaceRetouchingNaturalOutlined';

/**
 * Escala de Glogau: grau de fotoenvelhecimento da pele do rosto, do tipo I ao IV.
 * Referência clínica: classificação de Glogau (Glogau RG, 1996), usada em
 * protocolos de dermatologia estética. As faixas de idade são só típicas: a
 * escala mede o dano solar, não a idade. Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/glogau.php.
 */
const glogau = {
  key: 'glogau',
  name: 'Escala de Glogau',
  description: 'Grau de fotoenvelhecimento da pele, do I ao IV',
  details: 'Classifica o envelhecimento da pele causado pelo sol em quatro tipos, do I (sem rugas, sinais iniciais) ao IV (rugas em todo o rosto, pele fina e manchada). A idade de cada tipo é só uma referência: o que conta é o que a pele mostra. Ajuda a definir a intensidade do tratamento e a acompanhar a resposta ao longo do tempo. Um clique marca o tipo do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: FaceRetouchingNaturalOutlinedIcon,
  accent: 'pink',
  options: [
    { value: '1', label: 'Tipo I', caption: '20 a 30 anos', image: 'glogau-1.png', help: 'Sem rugas. Fotoenvelhecimento inicial, com alterações leves de pigmento.' },
    { value: '2', label: 'Tipo II', caption: '30 a 40 anos', image: 'glogau-2.png', help: 'Rugas só com a expressão, nos cantos dos olhos e da boca. Primeiras manchas.' },
    { value: '3', label: 'Tipo III', caption: '50 anos ou mais', image: 'glogau-3.png', help: 'Rugas visíveis em repouso. Manchas evidentes e pequenos vasos aparentes.' },
    { value: '4', label: 'Tipo IV', caption: '60 anos ou mais', image: 'glogau-4.png', help: 'Rugas em todo o rosto, sem áreas de pele lisa. Pele fina, amarelada e flácida.' },
  ],
};

export default glogau;
